import { getLocale } from '@/services/i18n';

export function getFaqUrl() {
  const locale = getLocale();

  if (locale === 'es') {
    return 'https://support.meetmyage.com/es/support/home';
  } else if (locale === 'de') {
    return 'https://support.meetmyage.com/de/support/home';
  } else {
    return 'https://support.meetmyage.com/support/home';
  }
}
